import React from 'react'
import {Link} from 'react-router-dom';
import "./Seal.css";
import tplogo from "../govlogo/tplogo.png"
import foilogo from "../govlogo/FOIlogo.png"





function Seal() {

  return (
    <>

    <div className='seal-container'>
        <section className='seal-icon'>
            <div className='image-container'>
                    <Link to='/transparencyseal'>
                    <img className='tplogo' src={tplogo} alt="logo" title='Transparency Seal' />
                    </Link>
                    <Link to = {{ pathname: 'https://www.foi.gov.ph'}} target= {"_blank"} >
                    <img className='foilogo' src={foilogo} alt="logo2" title='Freedom of Information'/>
                    </Link>
            </div>
        </section>
    </div>
    </>
  )

}

export default Seal;